import styled from "@emotion/styled";
import { Heading } from "../ui/heading";
import { Section } from "../layout/section";
import { Vertical } from "../ui/cards/vertical";
import { StaticImage } from "gatsby-plugin-image";
import StepOne from "../../svgs/seo/1.svg";
import StepTwo from "../../svgs/seo/2.svg";
import StepThree from "../../svgs/seo/3.svg";
import StepFour from "../../svgs/seo/4.svg";
import StepFive from "../../svgs/seo/5.svg";
import StepSix from "../../svgs/seo/6.svg";
import StepSeven from "../../svgs/seo/7.svg";
import StepEight from "../../svgs/seo/8.svg";
import StepNine from "../../svgs/seo/9.svg";
import StepTen from "../../svgs/seo/10.svg";
import StepEleven from "../../svgs/seo/11.svg";
import StepTwelve from "../../svgs/seo/12.svg";
import { Feature } from "../ui/cards/feature";
import { HorizontalCard } from "../ui/cards/horizontal";
import { Cta } from "../blog/cta";

const StyledProcess = styled.div`
  background-color: var(--off-white);

  .h2 {
    margin-bottom: var(--mimac);
  }

  p {
    max-width: 1140px;
  }

  .vertical-cards {
    margin-top: var(--x-small);
  }
`;

export const Process = () => (
  <StyledProcess>
    <Section>
      <div className="row">
        <Heading
          type="h2"
          className="h2"
          text="How Our White Label SEO Process Works"
        />
        <p>
          Looking for white label SEO services for agencies? Here is how Agency
          Elevation structures their white label SEO services. We have more
          in-depth materials available but these are some of the key components
          of our success for you and your clients’ SEO campaigns.
        </p>

        <div className="vertical-cards">
          <Vertical
            title="Onboarding"
            text="Using our custom portal you or your team can submit new SEO clients for onboarding in 1-2 minutes. We have built custom intake forms you'd simply fill out in your custom portal and upon submission our team immediately begins working on the new SEO campaign for your client; this is the fastest and easiest onboarding you'll find in the white label industry."
            step={{
              number: 1,
              src: StepOne,
            }}
          >
            <StaticImage
              src="../../images/seo/onboarding.png"
              alt="Onboarding"
              class="img-container"
            />
          </Vertical>

          <Vertical
            title="SEO Campaign Planning"
            text="During the onboarding process you'd provide us with any special insights or notes related to your client’s SEO campaign. This will help us ensure our keyword research is dialed in and specific to the goals of you and your client. We mold our keyword research and campaign around what you need to satisfy your client’s wants."
            step={{
              number: 2,
              src: StepTwo,
            }}
          >
            <StaticImage
              src="../../images/seo/campaign-planning.png"
              alt="SEO Campaign Planning"
              class="img-container"
            />
          </Vertical>

          <Vertical
            title="SEO Audit - Content Gaps"
            text="Before we can start optimizing pages our team of SEO specialists and experts will perform an in-depth and custom-tailored content gap analysis to determine if your client’s website needs additional content or pages to be added to achieve optimal rankings. Some sites are good and others need a lot of added content or pages. We determine this during onboarding so you and your clients will have no surprises down the road."
            step={{
              number: 3,
              src: StepThree,
            }}
          >
            <StaticImage
              src="../../images/seo/content-gaps.png"
              alt="SEO Audit - Content Gaps"
              class="img-container"
            />
          </Vertical>

          <Vertical
            title="SEO Audit - Backlinks"
            text="Before we can start optimizing pages our team of SEO specialists and experts will perform an in-depth and custom-tailored content gap analysis to determine if your client’s website needs additional content or pages to be added to achieve optimal rankings. Some sites are good and others need a lot of added content or pages. We determine this during onboarding so you and your clients will have no surprises down the road."
            step={{
              number: 4,
              src: StepFour,
            }}
          >
            <StaticImage
              src="../../images/seo/backlinks.png"
              alt="SEO Audit - Backlinks"
              class="img-container"
            />
          </Vertical>
        </div>

        <Feature
          title="SEO Audit - Site Performance"
          text="Core Web Vitals are a very important metric, commonly known as site speed and performance. When our team is performing all of the SEO audits, we’ll check your client’s website and assess what kind of work needs to be done to improve website performance to increase Core Web Vitals scores to improve load times and ultimately, increase rankings and conversions. Our team has SEO developers on staff that are experts in improving these metrics and making your clients’ websites much faster and in line with Google and their desires for good user experience."
          noBg={true}
          inverted={true}
          step={{
            src: StepFive,
            number: 5,
          }}
        >
          <StaticImage
            src="../../images/seo/site-performance.png"
            alt="Site Performance"
          />
        </Feature>

        <Feature
          title="Keyword Research"
          text="Arguably the most important factor to a successful white label SEO campaign is proper keyword research. This is why our team starts with thorough SEO audits at the onset and gets detailed SEO campaign planning details from your team regarding your client and their needs. We then tailor the keyword research for the white label SEO campaign to that information as it dictates our team’s direction and approach for on-page optimizations, title tags, meta descriptions, H1 and H2 tags, schema, internal linking, content creation, link building, GBP optimizations, and all other aspects of the campaign. We also ensure we are targeting competitive keywords that drive actual search volume so you know we are focused on results instead of inflating fake, long-tail keyword rankings that won’t drive sales or revenue for your client. And we research keyword topics and keyword clusters that will pair with a specific SEO strategy to move the needle and get your clients ranked higher on Google."
          noBg={true}
          step={{
            src: StepSix,
            number: 6,
          }}
        >
          <StaticImage
            src="../../images/seo/keyword-research.png"
            alt="Keyword Research"
          />
        </Feature>

        <Feature
          title="Content Writing & Creation"
          text="After establishing content gaps with our SEO audit process and then looking at detailed keyword research, we have a clear roadmap on which content to create, which pages need additional content, and which pages are missing completely and need to be added. Our team of writers are 100% USA-based, in-house, and trained heavily on writing based on users and not search engines. We create high-quality and custom content around Google's E-E-A-T guidelines and are always seeking to improve quality to ensure your clients’ campaigns are future proof and never at risk of violating any rules or using tactics like AI content which can get your clients in trouble. It’s also important to note our white label SEO content team is producing content for your target audience with actual search intent and readability in mind. No junk content here!"
          noBg={true}
          inverted={true}
          step={{
            src: StepSeven,
            number: 7,
          }}
        >
          <StaticImage
            src="../../images/seo/content-writing-creation.png"
            alt="Content Writing & Creation"
          />
        </Feature>

        <div className="cards">
          <HorizontalCard
            title="On-page Optimization"
            text="Once the new content is added or modified, our SEO specialists optimize all of the important aspects of your client’s white label SEO campaign. These elements typically include custom written title tags, meta descriptions, H1 tags, H2 tags, internal linking, custom-created schema code with proper node referencing (most agencies don’t offer this), and many more methods depending on need. You can rest assured your client’s website will be optimized A to Z with our white label SEO team leaving no stone unturned in an effort to deliver the best results to help increase value and reduce churn for your agency."
            step={{
              src: StepEight,
              number: 8,
            }}
          >
            <StaticImage
              src="../../images/seo/on-page-optimization.png"
              alt="On-page Optimization"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>

          <HorizontalCard
            title="Off-page Optimization"
            text="Off-page optimization is a broad topic that typically refers to link building, generating ranking signals, and improving external factors that help improve your clients’ Domain Authority (DA) or Domain Rating (DR). DA and DR are metrics that judge a domain or website and how authoritative they are in the eyes of Google. They scale from 0-100, with 0 indicating a brand new website with no authority and 100 indicating a massive website with extreme authority such as Google, YouTube, or other large websites with tons of backlinks. Our white label SEO services include off-page services to boost your clients’ authority and other important search engine ranking factors."
            step={{
              src: StepNine,
              number: 9,
            }}
          >
            <StaticImage
              src="../../images/seo/off-page-optimization.png"
              alt="Off-page Optimization"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>

          <HorizontalCard
            title="Link Building"
            text="Our white label SEO company services include link building services to help move the needle in improving your clients’ Domain Authority and Domain Rating. We build only white-hat and legitimate backlinks that are in line with what Google wants to see. We offer a variety of white label link building services including content syndication, citations, guest post links, and more!"
            step={{
              src: StepTen,
              number: 10,
            }}
          >
            <StaticImage
              src="../../images/seo/on-page-optimization.png"
              alt="Link Building"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>
        </div>

        <Feature
          title="Signal Generation"
          text="For white label SEO campaigns, beyond only link building, we use a proprietary method to generate ranking signals around your clients’ top priority keywords using a variety of methods that include creating custom content, syndication, and a mixture of high-quality backlinks along with using various Google API services to generate ranking signals on a monthly and consistent basis. This results in a strong local SEO strategy for GBP optimizations and rankings and also helps with organic keyword rankings as well."
          noBg={true}
          step={{
            src: StepEleven,
            number: 11,
          }}
        >
          <StaticImage
            src="../../images/seo/signal-generation.png"
            alt="Signal Generation"
          />
        </Feature>

        <Feature
          title="Results & Performance Monitoring"
          text="Tracking the success of your clients’ white label SEO campaigns is critical, and we use a variety of methods to monitor success and performance for our white label SEO management service. We use all of the standard tools including Google Analytics, Google Search Console, Google Business Profile Insights, organic keyword rankings, geogrid (heatmap) keyword rankings, local keyword rankings (Google mobile), Ahrefs, Semrush, Moz, Screaming Frog, Google Tag Manager, conversion tracking of forms and phone calls, and many other methods to assess true ROI and ensure accurate attribution. You'll love our custom portal which houses reports, files, tasks, activity logs, and more. Additionally, you’ll receive a white label SEO report that’s web based and will have your agency’s logo on it, and your clients can bookmark it and view a large number of SEO campaign metrics."
          inverted={true}
          step={{
            src: StepTwelve,
            number: 12,
          }}
        >
          <StaticImage
            src="../../images/seo/results-performance-monitoring.png"
            alt="Results & Performance Monitoring"
          />
        </Feature>
      </div>
    </Section>
  </StyledProcess>
);
